export const emailAddressMutationSitecoreLabels = {
  HeadingOldEmailAddress: { value: "Huidig e-mailadres" },
  InfoOldEmailAddress: { value: "Optioneel" },
  PlaceholderOldEmailAddress: { value: "Huidig e-mailadres" },
  TooltipOldEmailAddress: { value: "" },
  HeadingNewEmailAddress: { value: "Nieuw e-mailadres" },
  InfoNewEmailAddress: { value: "" },
  PlaceholderNewEmailAddress: { value: "Nieuw e-mailadres" },
  TooltipNewEmailAddress: { value: "" },
};
